import '@/assets/css/zoom-slider.css';

import L from 'leaflet';

import { createControlComponent } from '@react-leaflet/core';

interface CustomZoomSliderProps extends L.ControlOptions {
  sliderPosition?: 'leftside' | 'leftside-short' | 'rightside';
  className?: string;
}

// Control layer function for createControlComponent
const customZoomSliderLayer = (props: CustomZoomSliderProps) => {
  const positionClass = (props.sliderPosition === 'rightside') ? 'topright' : 'topleft';
  const className = props.className || '';
  const sliderPosition = props.sliderPosition || 'leftside';

  // Create a custom Leaflet control
  const CustomControl = L.Control.extend({
    onAdd: function (map: L.Map) {
      // Create a container div
      const container = L.DomUtil.create('div', 'custom-zoom-slider-control');

      // Disable click propagation
      L.DomEvent.disableClickPropagation(container);

      // Create the HTML structure directly
      container.innerHTML = `
        <div class="leaflet-zoomex leaflet-zoomex-${sliderPosition} ${className}">
          <button class="leaflet-zoomex-out" title="Map Zoom Out" aria-label="Zoom out">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M 8,0.5 A 7.5,7.5 0 0 0 0.5,8 7.5,7.5 0 0 0 8,15.5 7.5,7.5 0 0 0 15.5,8 7.5,7.5 0 0 0 8,0.5 Z m -3.5,6 h 7 c 0.554,0 1,0.446 1,1 v 1 c 0,0.554 -0.446,1 -1,1 h -7 c -0.554,0 -1,-0.446 -1,-1 v -1 c 0,-0.554 0.446,-1 1,-1 z" />
            </svg>
          </button>
          <div class="leaflet-zoomex-slider-container">
            <input type="range" class="leaflet-zoomex-slider" min="${map.getMinZoom()}" max="${map.getMaxZoom()}" value="${map.getZoom()}" step="1" title="Map Zoom In / Zoom Out Slider" aria-label="Zoom slider" />
          </div>
          <button class="leaflet-zoomex-in" title="Map Zoom In" aria-label="Zoom in">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M 8,0.5 A 7.5,7.5 0 0 0 0.5,8 7.5,7.5 0 0 0 8,15.5 7.5,7.5 0 0 0 15.5,8 7.5,7.5 0 0 0 8,0.5 Z m -0.5,3 h 1 c 0.554,0 1,0.446 1,1 v 2 h 2 c 0.554,0 1,0.446 1,1 v 1 c 0,0.554 -0.446,1 -1,1 h -2 v 2 c 0,0.554 -0.446,1 -1,1 h -1 c -0.554,0 -1,-0.446 -1,-1 v -2 h -2 c -0.554,0 -1,-0.446 -1,-1 v -1 c 0,-0.554 0.446,-1 1,-1 h 2 v -2 c 0,-0.554 0.446,-1 1,-1 z" />
            </svg>
          </button>
        </div>
      `;

      // Add event listeners
      const zoomOutBtn = container.querySelector('.leaflet-zoomex-out') as HTMLButtonElement;
      const zoomInBtn = container.querySelector('.leaflet-zoomex-in') as HTMLButtonElement;
      const slider = container.querySelector('.leaflet-zoomex-slider') as HTMLInputElement;

      if (zoomOutBtn) {
        L.DomEvent.on(zoomOutBtn, 'click', () => map.zoomOut());
      }

      if (zoomInBtn) {
        L.DomEvent.on(zoomInBtn, 'click', () => map.zoomIn());
      }

      if (slider) {
        L.DomEvent.on(slider, 'input', (e: any) => {
          map.setZoom(parseInt(e.target.value));
        });

        // Update slider when map zoom changes
        map.on('zoomend', () => {
          slider.value = map.getZoom().toString();
        });
      }

      return container;
    },

    onRemove: function (map: L.Map) {
      // Clean up event listeners
      map.off('zoomend');
    }
  });

  return new CustomControl({
    position: positionClass
  });
};

const CustomZoomSlider = createControlComponent(customZoomSliderLayer);

export { CustomZoomSlider };
export type { CustomZoomSliderProps };
